import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProjectDisplay from './pages/ProjectDisplay';
import StickyNotes from './components/StickyNotes';


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* New sticky notes home page */}
          <Route path='/' element={<StickyNotes />}/>
          
          {/* Old portfolio routes */}
          <Route path='/old/*' element={
            <>
              <Navbar />
              <Routes>
                <Route path='/' element={<Home />}/>
                <Route path='/projects' element={<Projects />}/>
                <Route path='/project/:id' element={<ProjectDisplay />} />
                <Route path='/about' element={<About />}/>
              </Routes>
              <Footer />
            </>
          }/>
        </Routes>
      </Router>
    </div>
  );
}
 
export default App;
